// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__xP4-c","signatureButtonsRight":"ModalSign_signatureButtonsRight__1xMNQ"};